import store from '@/stores'

const Layout = () => import('./components/ui/Layout')
const AmortizationCalculator = () => import('./pages/AmortizationCalculator')
const ProviderDetails = () => import('./pages/Providers/ProviderDetails')
const ProvidersList = () => import('./pages/Providers/ProvidersList')
const ProvidersListByCategory = () => import('./pages/Providers/ProvidersListByCategory')

export default [
  {
    path: '/resources',
    component: Layout,
    meta: { accessAnyWhere: true },
    children: [
      {
        path: 'calculator',
        name: 'AmortizationCalculator',
        component: AmortizationCalculator,
        meta: {
          title: 'Amortization Calculator',
        },
      },
      {
        path: 'providers',
        name: 'ProvidersList',
        component: ProvidersList,
        meta: {
          title: 'Providers',
        },
        beforeEnter: (to, from, next) => {
          const isAdmin = store.getters['authStore/isAdmin']
          return isAdmin ? next() : next('/')
        },
      },
      {
        path: 'providers/:category',
        name: 'ProvidersListByCategory',
        component: ProvidersListByCategory,
        props: true,
        meta: {
          title: 'Providers',
        },
        beforeEnter: (to, from, next) => {
          const isAdmin = store.getters['authStore/isAdmin']
          return isAdmin ? next() : next('/')
        },
      },
      {
        path: 'provider/:providerId',
        name: 'ProviderDetails',
        component: ProviderDetails,
        props: true,
        meta: {
          title: 'Provider Details',
        },
        beforeEnter: (to, from, next) => {
          const isAdmin = store.getters['authStore/isAdmin']
          return isAdmin ? next() : next('/')
        },
      },
    ],
  },
]
